import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#ccc"} }, null, -1)
const _hoisted_3 = { class: "flex flex-row flex-wrap gap-2 p-2 max-h-56 overflow-auto my-[4%]" }
const _hoisted_4 = { class: "px-4 py-2 rounded-full text-gray-500 bg-gray-200 font-semibold text-sm flex items-center align-center w-max ease" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.array, (item, index) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "chip",
            key: index
          }, [
            _createElementVNode("span", _hoisted_4, [
              (_ctx.itemParameter)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(item[_ctx.itemParameter]), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(item), 1)),
              _createVNode(_component_mdicon, {
                class: "cursor-pointer",
                name: "close",
                size: "21",
                onClick: ($event: any) => (_ctx.removeItem(Number(index)))
              }, null, 8, ["onClick"])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}